import { wordpressCategoryIds } from "../../pages/constants/wordpress";
import { WordPressActions } from "../constants/wordpress";

const WPEndPoint = "https://staging.trashwarrior.com/wp-json/wp/v2/posts";
const postSummaryFields = "id,slug,excerpt,title,categories,jetpack_featured_media_url,date_gmt";
const allCategoryIds = Object.values(wordpressCategoryIds);

export const getAllWordPressPosts = (category?: any) => async (dispatch: any, getState: Function) => {
  try {
    dispatch({ type: WordPressActions.LOADING_POSTS });
    const categories = category ? category : allCategoryIds.join(",");
    const response = await fetch(`${WPEndPoint}?_fields=${postSummaryFields}&per_page=100&categories=${categories}`);
    const data = await response.json();
    dispatch({ type: WordPressActions.SET_POSTS, payload: data });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    dispatch({ type: WordPressActions.RESET_POSTS });
  }
};
